import React from "react";
import "./detailsTab.css";
import { Tab,Row,Col,Nav} from "react-bootstrap";
import PortaritSlider from "../portraitSlider/portraitSlider";
import NPortaritSlider from "../portraitSlider/nportraitSlider";
import EpisodeList from "../episodeList/episodeList";
import MoreDetails from "../moredetails/moredetails";
import { useTranslation } from "react-i18next";

const DetailsTab = (props) =>
{

  const { t } = useTranslation(["translation"]);



return(<Tab.Container id={props.ider?props.ider:props.idet} defaultActiveKey={props.active} >
<Row className="tabist">
  <Col sm={12}>
  <Nav className="justify-content-center">
    {props.type==="season"?(
         <Nav.Item>
             <Nav.Link  eventKey="episodes">{t("tab_Episode")}</Nav.Link>
        </Nav.Item>
     
     
    ):("")}
    <Nav.Item>
      <Nav.Link eventKey="related">{t("tab_Related")}</Nav.Link>
    </Nav.Item>
    <Nav.Item>
      <Nav.Link eventKey="more_details">{t("tab_Details")}</Nav.Link>
    </Nav.Item>
  
  </Nav>
  
  </Col>
  <Col sm={12}>
    <Tab.Content>
      {props.type==="season"?( <Tab.Pane eventKey="episodes">
          <Row style={{paddingTop:"12px"}}>
              <Col sm={12}>
               
             
              </Col>
           
          </Row>
          <Row>
              <Col sm={12}>
              <EpisodeList {...props}></EpisodeList>
              </Col>
          </Row>
      
      </Tab.Pane>):("")}
      <Tab.Pane eventKey="related">
      {props.ally && props.id!==null?<PortaritSlider  name={props.data.urlName} information={props.id} {...props} key={props.data._id} header={false}></PortaritSlider>:props.id!=null && !props.ally?<NPortaritSlider name={props.data.urlName}   header={false} information={props.id} key={props.data._id} tabbed={false} {...props}></NPortaritSlider>:""}
       
      </Tab.Pane>
      <Tab.Pane eventKey="more_details">
      <MoreDetails {...props}></MoreDetails>
      </Tab.Pane>
    </Tab.Content>
  </Col>
</Row>
</Tab.Container>);
}

export default DetailsTab;